import React, { useState, useEffect } from "react"
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useDataJournalModel } from "../dataJournalModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { IBranchInsert, IBranchUpadata } from "../../dataBranch/dataBranchTypes";
import { setTitle } from "../../../../utils/utils"
import moment from "moment"
import { globalPrompt } from "../../../../components2/YhMessage"

const JournalDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState } = useNavModel()
    const { selectedRow, reviewCode } = useDataJournalModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams
    useEffect(() => {
        if (selectedRow.length != 0) {
            const { reviewTime, ...params } = selectedRow[0]
            const fromParams = {
                ...params,
                reviewTime: reviewTime ? moment(reviewTime) : undefined
            }
            form.setFieldsValue(fromParams)
        }
    }, [])
    const audit = () => {
        if(selectedRow[0].execStatus === 2) return globalPrompt("message", { type: "warning", text: "该日志已审核过"})
        const reduceArr = selectedRow.map(item => item.code) as string[]
        globalPrompt("modal", {
            title: "请求日志审核",
            text: `审核编码为${reduceArr.toString()}`,
            cancelShow: true,
            onOk: () => {
                const retData = reviewCode(reduceArr)
                return new Promise((resolve, reject) => {
                    if (retData) {
                        globalPrompt("message", { type: "success", text: "审核成功" })
                        resolve("1")
                    } else {
                        globalPrompt("message", { type: "error", text: "审核失败" })
                        reject("审核")
                    }
                })
            },
            onCancel: () => { console.log('关闭') }
        })
    }
    const items = [
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "数据目录",
            labelCol: { span: 6 },
            fieldName: "catalog",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "操作类型",
            labelCol: { span: 6 },
            fieldName: "execTypeName",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "执行状态",
            labelCol: { span: 6 },
            fieldName: "execStatusName",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "审核人",
            labelCol: { span: 6 },
            fieldName: "reviewer",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "来源",
            labelCol: { span: 6 },
            fieldName: "sourceApp",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "发起日期",
            labelCol: { span: 6 },
            fieldName: "createTime",
            showTime: true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "审核日期",
            labelCol: { span: 6 },
            fieldName: "reviewTime",
            showTime: true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "备注",
            labelCol: { span: 6 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.JsonView,
            span: 16,
            fieldLabel: "执行数据",
            labelCol: { span: 3 },
            fieldName: "execData",
            // json:JSON.stringify(selectedRow[0]?.["execData"]??null),
            json: selectedRow[0]?.["execData"] ?? null,
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}请求日志</div>
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => audit()}
        >审核</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { addNav("1-3"); closeNav(id) }}
        >取消</Button>
    </>
    return <Form
        form={form}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default JournalDetail